module.exports = __webpack_public_path__ + "img/LichtetDenAnker.314d0d1c.svg";